import axios, {AxiosInstance, AxiosResponse, InternalAxiosRequestConfig} from 'axios';
import Cookies from 'js-cookie';

// Create a typed Axios instance
const apiInstance: AxiosInstance = axios.create({
	baseURL: 'https://6fyl8swazj.execute-api.us-west-2.amazonaws.com/dev/',
	timeout: 30000,
});

function requestInterceptor(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
	const token = Cookies.get('authToken');
	if (token) {
		config.headers = config.headers || {} as any;
		// Ensure we set Authorization header string
		(config.headers as any)['Authorization'] = `Bearer ${token}`;
	}
	return config;
}

function responseInterceptor<T = any>(response: AxiosResponse<T>): AxiosResponse<T> {
	try {
		const data: any = response.data;
		if (data?.token) {
			Cookies.set('authToken', data.token);
		}
	} catch (_) {
		// Silently ignore token set errors
	}
	return response;
}

apiInstance.interceptors.request.use(requestInterceptor);
apiInstance.interceptors.response.use(responseInterceptor);

export default apiInstance;
export type {AxiosInstance, AxiosResponse};
